




import { Component, Mixins } from "vue-property-decorator";
import DoKoSvgImgMixin from "../mixins/DoKoSvgImgMixin.vue";

@Component({ components: {} })
export default class DoKoCard extends Mixins(DoKoSvgImgMixin) {
  readonly imgList = "card";
}
